import React from "react";
import {
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Collapse,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { MethodChoice } from "./orderNotificationPreferences";

export interface FrequencyMethodRowProps {
  label: string;
  checked: boolean;
  onCheckedChange: (val: boolean) => void;
  method: MethodChoice;
  onMethodChange: (val: MethodChoice) => void;
  methodTestId?: string;
  showMethod?: boolean;
}

const FrequencyMethodRow: React.FC<FrequencyMethodRowProps> = ({
  label,
  checked,
  onCheckedChange,
  method,
  onMethodChange,
  methodTestId,
  showMethod,
}) => {
  const show = showMethod ?? checked;

  const handleCheck = (_: React.ChangeEvent<HTMLInputElement>, v: boolean) => {
    onCheckedChange(v);
    if (!v) onMethodChange(MethodChoice.Email);
  };

  return (
    <Grid container sx={{ alignItems: "center" }}>
      <Grid item xs={12} md={6}>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox size="small" checked={checked} onChange={handleCheck} />
            }
            label={
              <Typography className="notification-title">{label}</Typography>
            }
          />
        </FormGroup>
      </Grid>

      <Grid item xs={12} md={6}>
        <Collapse in={show} mountOnEnter unmountOnExit>
          <ToggleButtonGroup
            exclusive
            value={method}
            onChange={(_, v: MethodChoice) =>
              onMethodChange(v ?? MethodChoice.Email)
            }
            aria-label="method"
            size="small"
            data-testid={methodTestId}
            sx={{
              float: "left",
              border: "1px solid #000",
              borderRadius: "6px",
              backgroundColor: "#f5f5f5",
              overflow: "hidden",
              "& .MuiToggleButton-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "13px",
                color: "#333",
                border: "none",
                borderRadius: 0,
                px: 2.5,
                py: 0.25,
                "&:hover": {
                  backgroundColor: "#e9e9e9",
                },
                "&.Mui-selected": {
                  borderRadius: "3px",
                  backgroundColor: "#62b5e5",
                  color: "#fff",
                  fontWeight: 700,
                  "&:hover": {
                    backgroundColor: "#62b5e5",
                  },
                },
              },
            }}
          >
            <ToggleButton value={MethodChoice.Email}>Email</ToggleButton>
            <ToggleButton value={MethodChoice.Text}>Text</ToggleButton>
            <ToggleButton value={MethodChoice.Both}>Both</ToggleButton>
          </ToggleButtonGroup>
        </Collapse>
      </Grid>
    </Grid>
  );
};

export default FrequencyMethodRow;
